var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slip"},[_c('header',[_vm._t("header",function(){return [_c('img',{staticClass:"logo",attrs:{"src":"/img/logo.svg?pod","alt":"Pod"}})]})],2),_c('article',[_vm._t("default")],2),_c('footer',[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }